import '../css/app.css';
import { createInertiaApp, router } from '@inertiajs/react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import { initSentry } from './sentry';

const env = import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development';

if (env === 'production') {
    initSentry();
}

router.on('navigate', () => {
    if (typeof window.ym === 'function') {
        window.ym(109603448, 'hit', window.location.href);
    }
});

const pages = import.meta.glob('./Pages/**/*.tsx');

createInertiaApp({
    title: (title) => title || 'Kinoway',
    resolve(name) {
        const page = pages[`./Pages/${name}.tsx`];
        if (!page) throw new Error(`Page not found: ${name}`);
        return page();
    },
    setup({ el, App, props }) {
        i18n.changeLanguage(props.initialPage.props.locale);
        const app = <I18nextProvider i18n={i18n}><App {...props} /></I18nextProvider>;
        // A document-level Back/Forward restores Inertia's remembered tabs and
        // seasons, which differ from the fresh SSR HTML. Mount that history
        // snapshot on the client rather than hydrating the server defaults.
        const restoringSeriesHistory = props.initialPage.component === 'Series/Show'
            && performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
        if (el.dataset.serverRendered === 'true' && !restoringSeriesHistory) {
            hydrateRoot(el, app);
        } else {
            createRoot(el).render(app);
        }
    },
    progress: {
        color: '#8b5cf6',
    },
});
